/**
 * @generated SignedSource<<66ab68b1a43af9761032b75faa710538>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AddScreenSetNameMutation$variables = {
  name: string;
  screenId: string;
};
export type AddScreenSetNameMutation$data = {
  readonly storecast: {
    readonly setScreenName: {
      readonly id: string;
    };
  };
};
export type AddScreenSetNameMutation = {
  response: AddScreenSetNameMutation$data;
  variables: AddScreenSetNameMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "screenId"
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StorecastMutation",
    "kind": "LinkedField",
    "name": "storecast",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          },
          {
            "kind": "Variable",
            "name": "screenId",
            "variableName": "screenId"
          }
        ],
        "concreteType": "StorecastScreen",
        "kind": "LinkedField",
        "name": "setScreenName",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AddScreenSetNameMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AddScreenSetNameMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "1819094750dd61f7531e19d51cd8999f",
    "id": null,
    "metadata": {},
    "name": "AddScreenSetNameMutation",
    "operationKind": "mutation",
    "text": "mutation AddScreenSetNameMutation(\n  $screenId: ID!\n  $name: String!\n) {\n  storecast {\n    setScreenName(screenId: $screenId, name: $name) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0b13698e07576fadd70552133739989f";

export default node;
